export const UPDATE_POOL_REQUEST_SUCCESS = 'UPDATE_POOL_REQUEST_SUCCESS';

export const updatePoolRequestSuccess = ({ poolRequest }) => ({
    type: UPDATE_POOL_REQUEST_SUCCESS,
    payload: {
        poolRequest,
    },
});
